import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Box } from '@mui/material';
import { useStyles } from '~/views/atoms/circle-counter/useStyles';
import clsx from 'clsx';
export const CircleCounter = ({ counter, className }) => {
    const classes = useStyles();
    return (_jsx(Box, { letterSpacing: counter > 9 ? '0.5px' : 0, className: clsx(classes.circleContainer, classes.counterNumber, className), children: counter }));
};
